import { useTranslation } from 'next-i18next'

import ROUTES from '~/shared/constants/routes.const'
import { Link } from '~/components'
import { togglePreviewSiteActionCreator } from '~/redux/slices/ui'
import { useAppDispatch, useAppSelector } from '~/redux/hooks'
import accountAnalytics from '~/analytics/account/accountAnalytics'
import Button from '~/components/Buttons/Button'
import { isAuthenticated } from '~/auth/slices/auth.slice'
import { useHomeLink } from '~/hooks/useHomeLink'
import SVGImage from '~/components/Image/SVGImage'
import HamburgerMenu from '~/menu/components/HamburgerMenu'
import { selectStreakDays } from '~/redux/slices/user'

const mediaQuery = [{ screen: '(min-width: 280px)', width: '60vw' }]

export default function DonationNavbar(): React.ReactElement {
  const { t } = useTranslation(['generics', 'home', 'imageAlt', 'menu'])
  const dispatch = useAppDispatch()
  const authenticated = useAppSelector(isAuthenticated)

  const handleOnPreviewClick = (): void => {
    dispatch(togglePreviewSiteActionCreator(true))
    accountAnalytics.logSneakPreview()
  }
  const logoRoute = useHomeLink()

  const dailyStreak = useAppSelector(selectStreakDays)
  const streakDays = dailyStreak ?? 1

  return (
    <nav className="sticky z-header top-0 h-14 md:h-16 bg-purple-abyss border-0 border-b border-solid border-purple-lilac-fade drop-shadow-navbar">
      <div className="h-full px-3 md:px-12 flex justify-between text-white">
        <section className="space-x-3 md:space-x-12 flex items-center">
          <Link to={logoRoute}>
            <SVGImage
              alt={t('imageAlt:icons.houseOfMath')}
              height={40}
              imageClassName="h-8 md:h-10 w-auto"
              srcKey="logos/house-of-math-white.svg"
              width={208}
            />
          </Link>
        </section>

        {authenticated ? (
          <section className="space-x-0 md:space-x-12 flex items-center gap-8 ml-8">
            {streakDays >= 2 && (
              <p className="md:pl-8 sm:pl-4 font-medium letter tracking-normal flex flex-grow align-center justify-end">
                <SVGImage
                  alt={t('imageAlt:streakFlame')}
                  imageClassName="flex justify-center items-center"
                  mediaQuery={mediaQuery}
                  srcKey="icons/on_fire.svg"
                />
                <span className="text-xs md:text-sm text-white ml-1">{t('menu:daysStreak', { days: streakDays })}</span>
              </p>
            )}
            {authenticated && <HamburgerMenu isDonationLayout />}
          </section>
        ) : (
          <section className="space-x-0 md:space-x-12 flex items-center">
            <div className="hidden md:flex transition-colors delay-200 hover:text-purple-bright">
              <Link onClick={handleOnPreviewClick} to={ROUTES.DASHBOARD}>
                <span className="font-medium">{t('home:previewSite')}</span>
              </Link>
            </div>
            <Button
              className="bg-transparent rounded-full text-white underline !text-btn-md transition-colors delay-200 hover:text-purple-bright"
              href={ROUTES.LOGIN}
              size="x-small"
            >
              {t('generics:logIn')}
            </Button>
          </section>
        )}
      </div>
    </nav>
  )
}
